





























































import Vue from 'vue'
import ConfirmDialog from '@/components/elements/ConfirmDialog.vue'
import { Carousel2ElInterface, Carousel2ElItemInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'Carousel2El',

  components: { ConfirmDialog },

  props: {
    templateItemData: {
      type: Object as () => Carousel2ElInterface,
      required: true
    }
  },

  data: () => ({
    showPopup: false,
    currentIndex: -1,
    selectedImage: {} as Carousel2ElItemInterface
  }),

  methods: {
    handleChange (newIndex:number) {
      this.currentIndex = newIndex
    },
    goToUri (item: Carousel2ElItemInterface) {
      if (Object.prototype.hasOwnProperty.call(item.action, 'confirmDialog')) {
        this.selectedImage = item
        this.showPopup = true

        return
      }
      let content:typeof item.action.uri | typeof item.action.content = ''
      if (item.action.uri) {
        content = item.action.uri
      } else if (item.action.content) {
        content = item.action.content
      }
      this.getView(item.action.view, content, null, item.action.jumpOnCloseUri || '')
    }
  }
})
